import { EmbeddedPdf } from "./EmbeddedPdf";

export const PrivacyPolicy = () => {
  return <EmbeddedPdf pdfType="privacy_policy" />;
};
